export const navLinks = [
  {
    id: "about",
    title: "About",
  },
  {
    id: "exp",
    title: "Experience",
  },
  {
    id: "project",
    title: "Projects",
  },
  {
    id: "profiles",
    title: "Profiles",
  },
  {
    id: "contact",
    title: "Contact",
  },
];

const projects = [
  {
    name: "Recipe Hub",
    description:
      "🍳🌮🍲 Recipe Web App 🥗📱: A delightful platform for foodies! 🎉 Create, explore, and save your favorite recipes with ease. ",
    tags: ["NodeJS", "ReactJS", "ExpressJS", "HTML/CSS","MongoDB"],
    source_code_link: "https://github.com/kamleshjoshi8102/frontend-recipe",
  },
  {
    name: "Chat App",
    description:
      "React chat app with Socket.io and Node.js, enabling real-time communication and seamless integration between frontend and backend.",
    tags: ["NodeJS", "ReactJS", "ExpressJS", "HTML/CSS", "Socket.io"],
    source_code_link: "https://github.com/kamleshjoshi8102/frontend-chatapp",
  },
  {
    name: "Text Ananlyzer",
    description:
      "Text Analyzer is a utility which can be used to manipulate your text in the way you want. It allows us to extract useful information from text, such as word count, and sentence count.",
    tags: ["JavaScript", "React", "HTML/CSS"],
    source_code_link: "https://github.com/kamleshjoshi8102/Text-Analyzer",
  },
  {
    name: "Braille Text Converter",
    description:
      "Braille to English text converter is a machine learning and web-based project that aims to convert Braille language into English text which is made in React and Django as backend.",
    tags: ["Machine Learning", "React", "Django"],
    source_code_link: "https://github.com/",
  },
  {
    name: "NewsMonkey App",
    description:
      "Newsmonkey is a news application that retrieves news from an API, providing users with up-to-date information and diverse news articles.",
    tags: ["React", "JavaScript", "HTML/CSS"],
    source_code_link: "https://github.com/kamleshjoshi8102/NewsMonkey",
  },
  {
    name: "Tinder Clone",
    description:
      " Full-stack fully functional Tinder clone application using JavaScript, React.js, Material-UI, and some Firebase services like Firebase hosting and Cloud Database.",
    tags: ["React", "MONGODB", "ExpressJS", "firebase"],
    source_code_link: "https://github.com/kamleshjoshi8102/tinder",
  },
  {
    name: "Text Editor",
    description:
      "The Text Editor project is a JavaScript-based application that utilizes a stack data structure to enable undo and redo functionality, empowering users to easily manage their text edits and revert changes as needed.",
    tags: ["React", "JavaScript", "HTML/CSS", "DSA"],
    source_code_link: "https://github.com/kamleshjoshi8102/tinder",
  },
  {
    name: "CSS-Practice",
    description:
      "Some projects which are purely made with the help of CSS to test my design skills.",
    tags: ["CSS", "HTML", "JavaScript"],
    source_code_link: "https://github.com/kamleshjoshi8102/CSS-Practice",
  },
  {
    name: "Dice Game",
    description:
      "The Dice Game is an interactive web application developed using HTML, CSS, JavaScript, and Bootstrap. It allows users to roll virtual dice, providing a fun and engaging gaming experience. The game's design and functionality are enhanced by the use of Bootstrap, making it visually appealing and responsive across different devices.",
    tags: ["Bootstrap", "JavaScript", "HTML/CSS"],
    source_code_link:
      "https://github.com/kamleshjoshi8102/Web_Development_projects/tree/main/Dice_Game",
  },
  {
    name: "Drum Kit",
    description:
      "The Drum Kit project is a web application built using HTML, CSS, JavaScript, and Bootstrap. It allows users to play virtual drums by pressing corresponding keys or clicking on drum pads, creating an interactive and immersive musical experience.",
    tags: ["Bootstrap", "JavaScript", "HTML/CSS"],
    source_code_link:
      "https://github.com/kamleshjoshi8102/Web_Development_projects/tree/main/Drum_Kit",
  },
];

export { projects };

/*

    <div className="project__about">
                <h3>Chat App</h3>
                <p className="project__about__text">
                  React chat app with Socket.io and Node.js, enabling real-time
                  communication and seamless integration between frontend and
                  backend."
                </p>
                <div className="project__tags">
                  <p>NodeJS</p>
                  <p>ReactJS</p>
                  <p>ExpresJS</p>
                </div>
              </div>
              <div className="project__links">
                <Link to=""> Know More </Link>
                <svg
                  fill="currentColor"
                  height="1em"
                  stroke="currentColor"
                  strokeWidth="0"
                  viewBox="0 0 1024 1024"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M869 487.8L491.2 159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 5.2-2L869 536.2a32.07 32.07 0 0 0 0-48.4z"></path>
                </svg>
              </div>
            </div>
*/

export const data1 = {
  labels: [
    "ReactJs",
    "NextJs",
    "MongoDB",
    "ExpressJS",
    "react-semantic-ui",
    "Bootstrap",
  ],
  datasets: [
    {
      label: "How much I have worked?",
      data: [20, 10, 10, 10, 15, 15],
      backgroundColor: [
        "rgba(255, 99, 132, 0.2)",
        "rgba(54, 162, 235, 0.2)",
        "rgba(255, 206, 86, 0.2)",
        "rgba(75, 192, 192, 0.2)",
        "rgba(153, 102, 255, 0.2)",
        "rgba(255, 159, 64, 0.2)",
      ],
      borderColor: [
        "rgba(255, 99, 132, 1)",
        "rgba(54, 162, 235, 1)",
        "rgba(255, 206, 86, 1)",
        "rgba(75, 192, 192, 1)",
        "rgba(153, 102, 255, 1)",
        "rgba(255, 159, 64, 1)",
      ],
      borderWidth: 1,
    },
  ],
};
export const data2 = {
  labels: ["C++/C", "JavaScript", "Python", "SQL", "HTML/CSS/SCSS", "Java"],
  datasets: [
    {
      label: "How much I have worked?",
      data: [50, 20, 10, 10, 20, 10],
      backgroundColor: [
        "rgba(255, 99, 132, 0.2)",
        "rgba(54, 162, 235, 0.2)",
        "rgba(255, 206, 86, 0.2)",
        "rgba(75, 192, 192, 0.2)",
        "rgba(153, 102, 255, 0.2)",
        "rgba(255, 159, 64, 0.2)",
      ],
      borderColor: [
        "rgba(255, 99, 132, 1)",
        "rgba(54, 162, 235, 1)",
        "rgba(255, 206, 86, 1)",
        "rgba(75, 192, 192, 1)",
        "rgba(153, 102, 255, 1)",
        "rgba(255, 159, 64, 1)",
      ],
      borderWidth: 1,
    },
  ],
};
export const data3 = {
  labels: [
    "Ubuntu",
    "Git/GitHub",
    "VSCode/Sublime Text",
    "Postman",
    "MySQL",
    "Jira",
  ],
  datasets: [
    {
      label: "How much I have worked?",
      data: [50, 40, 50, 10, 15, 15],
      backgroundColor: [
        "rgba(255, 99, 132, 0.2)",
        "rgba(54, 162, 235, 0.2)",
        "rgba(255, 206, 86, 0.2)",
        "rgba(75, 192, 192, 0.2)",
        "rgba(153, 102, 255, 0.2)",
        "rgba(255, 159, 64, 0.2)",
      ],
      borderColor: [
        "rgba(255, 99, 132, 1)",
        "rgba(54, 162, 235, 1)",
        "rgba(255, 206, 86, 1)",
        "rgba(75, 192, 192, 1)",
        "rgba(153, 102, 255, 1)",
        "rgba(255, 159, 64, 1)",
      ],
      borderWidth: 1,
    },
  ],
};
export const data4 = {
  labels: [
    "Leadership",
    "Teamwork",
    "Public Speaking",
    "Creative",
    "Innovative",
    "Problem Solving",
  ],
  datasets: [
    {
      label: "How much I have worked?",
      data: [40, 30, 20, 30, 35, 50],
      backgroundColor: [
        "rgba(255, 99, 132, 0.2)",
        "rgba(54, 162, 235, 0.2)",
        "rgba(255, 206, 86, 0.2)",
        "rgba(75, 192, 192, 0.2)",
        "rgba(153, 102, 255, 0.2)",
        "rgba(255, 159, 64, 0.2)",
      ],
      borderColor: [
        "rgba(255, 99, 132, 1)",
        "rgba(54, 162, 235, 1)",
        "rgba(255, 206, 86, 1)",
        "rgba(75, 192, 192, 1)",
        "rgba(153, 102, 255, 1)",
        "rgba(255, 159, 64, 1)",
      ],
      borderWidth: 1,
    },
  ],
};

export const options = {
  plugins: {
    tooltip: {
      callbacks: {
        label: function (context) {
          const label = context.label || "";
          const value = context.dataset.data[context.dataIndex] || 0;
          const total = context.dataset.data.reduce((a, b) => a + b, 0);
          const percentage = ((value / total) * 100).toFixed(2);
          return label + ": " + percentage + "%";
        },
      },
    },
  },
};
